import {getUtmTestParameters} from "./UtmParser";
import queryString from "query-string";
import {assertEqual} from "../../unittests/UnitTestHelper";
import {parseProductParams} from "./ProdcutParamsParser";
import {appdata} from "../../logic_tmp/appdata/AppData";


export function testPriceCalculator()
{
    testDynamicPrices()
    testFixedPrices()
    testSpecialProposalRedim()
}

export function testSpecialProposalRedim() {
    let str = getUtmTestParameters() + "&productCode=TEST_CONCERT-2030_01_01_MUSTPEAD-SHARED-DISCOUNT&spKeyRedim=SHARE50"
    let res = {}
    let queryParams = queryString.parse(str)
    parseProductParams(queryParams, res)
    assertEqual("TEST_CONCERT-2030_01_01_MUSTPEAD-SHARED-DISCOUNT", res.productCode)
    let prod = JSON.parse(JSON.stringify(res.product))
    calculatePricesAndCounts(res,prod)
    assertEqual(5, res.priceFull)

}


function testFixedPrices() {
    let str = getUtmTestParameters() + "&productCode=TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-2"
    let res = {}
    let queryParams = queryString.parse(str)
    parseProductParams(queryParams, res)
    assertEqual("TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-2", res.productCode)
    let prod = JSON.parse(JSON.stringify(res.product))
    calculatePricesAndCounts(res,prod)
    assertEqual(10, res.priceFull)
    assertEqual(7, res.priceReduced)
}



function testDynamicPrices() {
    let str = getUtmTestParameters() + "&productCode=TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-0"
    let res = {}
    let queryParams = queryString.parse(str)
    parseProductParams(queryParams, res)
    assertEqual("TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-0", res.productCode)

    let prod = JSON.parse(JSON.stringify(res.product))

    prod.fullPrice = 18
    prod.reducedPrice = 12
    prod.autoDiscount.autoDiscount_offsetPercent = 0
    prod.autoDiscount.autoDiscount_stepSizeDays = 1
    prod.autoDiscount.autoDiscount_offsetDays = 0
    prod.autoDiscount.autoDiscount_percentPerDay = 0

    calculatePricesAndCounts(res,prod)
    assertEqual(18, res.priceFull)
    assertEqual(12, res.priceReduced)
    prod.autoDiscount.autoDiscount_offsetPercent = 10
    prod.nowStr = "01.01.2030"
    calculatePricesAndCounts(res,prod)
    assertEqual(0, res.daysTillEvent)
    assertEqual(16.2, res.priceFull)
    assertEqual(10.8, res.priceReduced)
    assertEqual("01.01.2030", res.discountTill)
    prod.nowStr = "31.12.2029"
    prod.autoDiscount.autoDiscount_percentPerDay = 1
    prod.autoDiscount.autoDiscount_stepSizeDays = 1
    prod.autoDiscount.autoDiscount_offsetDays = 0
    calculatePricesAndCounts(res,prod)
    assertEqual(1, res.daysTillEvent)
    assertEqual(11, res.discount)
    assertEqual(16.02, res.priceFull)
    assertEqual(10.68, res.priceReduced)
    assertEqual("31.12.2029", res.discountTill)
    prod.nowStr = "22.12.2029"
    prod.autoDiscount.autoDiscount_percentPerDay = 1
    prod.autoDiscount.autoDiscount_stepSizeDays = 1
    calculatePricesAndCounts(res,prod)
    assertEqual(10, res.daysTillEvent)
    assertEqual(20, res.discount)
    assertEqual(14.4, res.priceFull)
    assertEqual(9.6, res.priceReduced)
    assertEqual("22.12.2029", res.discountTill)

    prod.autoDiscount.autoDiscount_percentPerDay = 1
    prod.autoDiscount.autoDiscount_stepSizeDays = 5
    calculatePricesAndCounts(res,prod)
    assertEqual(10, res.daysTillEvent)
    assertEqual(20, res.discount)
    assertEqual(14.4, res.priceFull)
    assertEqual(9.6, res.priceReduced)
    assertEqual("22.12.2029", res.discountTill)

    prod.nowStr = "23.12.2029"
    calculatePricesAndCounts(res,prod)
    assertEqual(9, res.daysTillEvent)
    assertEqual(15, res.discount)
    assertEqual(15.3, res.priceFull)
    assertEqual(10.19, res.priceReduced)
    assertEqual("27.12.2029", res.discountTill)
    prod.nowStr = "27.12.2029"
    calculatePricesAndCounts(res,prod)
    assertEqual(5, res.daysTillEvent)
    assertEqual(15, res.discount)
    assertEqual(15.3, res.priceFull)
    assertEqual(10.19, res.priceReduced)
    assertEqual("27.12.2029", res.discountTill)
    prod.nowStr = "28.12.2029"
    calculatePricesAndCounts(res,prod)
    assertEqual(4, res.daysTillEvent)
    assertEqual(10, res.discount)
    assertEqual(16.2, res.priceFull)
    assertEqual(10.8, res.priceReduced)
    assertEqual("01.01.2030", res.discountTill)

    prod.autoDiscount.autoDiscount_percentPerDay = 0.3
    prod.autoDiscount.autoDiscount_stepSizeDays = 5
    prod.autoDiscount.autoDiscount_offsetDays = 10
    prod.autoDiscount.autoDiscount_offsetPercent = 20
    prod.nowStr = "02.11.2029"
    calculatePricesAndCounts(res,prod)
    assertEqual(60, res.daysTillEvent)
    assertEqual(35, res.discount)
    assertEqual(11.7, res.priceFull)
    assertEqual(7.8, res.priceReduced)
    assertEqual("02.11.2029", res.discountTill)
    prod.nowStr = "03.11.2029"
    calculatePricesAndCounts(res,prod)
    assertEqual(59, res.daysTillEvent)
    assertEqual(33.5, res.discount)
    assertEqual(11.97, res.priceFull)
    assertEqual(7.98, res.priceReduced)
    assertEqual("07.11.2029", res.discountTill)

    assertEqual(2, res.countFull)
    assertEqual(2, res.count)
    assertEqual(23.94, res.amount)

}


export function parseDateStr(dateStr) {
    const [day, month, year] = dateStr.split(".");
    return new Date(+year, +month - 1, +day);
}

export function calculatePricesAndCounts(ret, product) {
    console.log("Ret111" + product)
    ret.priceFull = product.fullPrice
    ret.priceReduced = product.reducedPrice
    let autoDiscountConfig = product.autoDiscount
    let eventDate = parseDateStr(product.date)

    let nowDate = Date.now()
    if (product.nowStr !== undefined)
    {
        nowDate = parseDateStr(product.nowStr)
    }
    ret.daysTillEvent = Math.floor((eventDate - nowDate)/(24*3600*1000));
    ret.discountTill = undefined

    if (autoDiscountConfig !== undefined && !autoDiscountConfig.disabled)
    {
        if (autoDiscountConfig["autoDiscount_ankorDate"] !== undefined)
        {
            eventDate = parseDateStr(autoDiscountConfig["autoDiscount_ankorDate"])
            ret.daysTillEvent = Math.floor((eventDate - nowDate)/(24*3600*1000));
        }
        ret.discount = (Math.floor((ret.daysTillEvent - autoDiscountConfig.autoDiscount_offsetDays) / autoDiscountConfig.autoDiscount_stepSizeDays))* autoDiscountConfig.autoDiscount_stepSizeDays * autoDiscountConfig.autoDiscount_percentPerDay + autoDiscountConfig.autoDiscount_offsetPercent;
        let duration = (ret.daysTillEvent - autoDiscountConfig.autoDiscount_offsetDays) % autoDiscountConfig.autoDiscount_stepSizeDays;
        let someDate = new Date()
        if (product.nowStr !== undefined)
        {
            someDate = parseDateStr(product.nowStr)
        }
        someDate.setTime(someDate.getTime() +  (duration * 24 * 60 * 60 * 1000));
        ret.discountTill = ('0' + someDate.getDate()).slice(-2) + '.' + ('0' + (someDate.getMonth()+1)).slice(-2) + '.' + someDate.getFullYear();

        someDate.setTime(someDate.getTime() +  (24 * 60 * 60 * 1000));

        // Default format: dd.mm.yyyy
        ret.discountTillMessage = ('0' + someDate.getDate()).slice(-2) + '.' + ('0' + (someDate.getMonth()+1)).slice(-2) + '.' + someDate.getFullYear();

        // Special formatting for USD
        if (ret.currency === "$") {
            console.log("Currency is $")
            const months = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            const day = someDate.getDate();
            const month = months[someDate.getMonth()];
            const year = someDate.getFullYear();

            const formattedDate = `${month} ${day}, ${year}`;

            ret.discountTillMessage = formattedDate;
        }
        // For EUR and other currencies, keep dd.mm.yyyy format
        console.log("Discount till " + ret.discountTillMessage)

        if (product.fullPrice === NaN || product.fullPrice === 0)
            throw Error("Invalid fullPrice " +  product.fullPrice)
        ret.priceFull = Math.floor(product.fullPrice  * (100 - ret.discount)) / 100
        if (product.reducedPrice !== undefined)
            ret.priceReduced = Math.floor(product.reducedPrice * (100 - ret.discount)) / 100
    }
    if (ret.priceReduced === undefined)
    {
        ret.priceReduced = 0
    }
    if (ret.key2 !== undefined)
    {
        if (!product.priceInUrlAllowed)
            throw Error("Unexpected priceInUrl!")
        ret.priceFull = parseInt(ret.key2.split("A")[1])/100
        ret.priceReduced = parseInt(ret.key2.split("A")[2])/100
    }
    if (ret.spKeyRedim !== undefined)
    {


        if (ret.spKeyRedim === "SHARE35")
        {
            ret.priceFull = ret.priceFull * 0.65
            ret.priceReduced = ret.priceReduced * 0.65
        }
        if (ret.spKeyRedim === "SHARE25")
        {
            ret.priceFull = ret.priceFull * 0.75
            ret.priceReduced = ret.priceReduced * 0.75
        }

        if (ret.spKeyRedim === "SHARE30")
        {
            ret.priceFull = ret.priceFull * 0.7
            ret.priceReduced = ret.priceReduced * 0.7
        }

        if (ret.spKeyRedim === "SHARE40")
        {
            ret.priceFull = ret.priceFull * 0.6
            ret.priceReduced = ret.priceReduced * 0.6
        }

        if (ret.spKeyRedim === "SHARE50")
        {
            ret.priceFull = ret.priceFull / 2
            ret.priceReduced = ret.priceReduced / 2
        }
        if (ret.spKeyRedim === "SHARE100")
        {
            if (product["priceModel"] !== "FREE")
            {
                ret.spKeyRedim = undefined
                ret.errorMessageKey = "NoFreeTicketsLeft"
            }
            else {
                ret.priceFull = 0
                ret.priceReduced = 0
            }
        }
        if (ret.spKeyRedim === "HISP20")
        {
            ret.priceFull = ret.priceFull * 0.8
            ret.priceReduced = ret.priceReduced * 0.8
        }
        if (ret.spKeyRedim === "BASIANI")
        {
            ret.priceFull = ret.priceFull * 0.8
            ret.priceReduced = ret.priceReduced * 0.8
        }
        if (ret.spKeyRedim === "CELLO")
        {
            ret.priceFull = ret.priceFull * 0.8
            ret.priceReduced = ret.priceReduced * 0.8
        }
        if (ret.spKeyRedim === "BLACKFRIDAY")
        {
            console.log("BLACKFRIDAY")
            let specialProposalConfig = appdata.product["specialProposalConfig"][appdata.spKeyRedim]
            ret.priceFull = ret.priceFull * (100 - specialProposalConfig["discountValue"]) / 100
            ret.priceReduced = ret.priceReduced * (100 - specialProposalConfig["discountValue"]) / 100
        }

    }
    ret.priceFull = Math.floor(ret.priceFull  * 100) / 100
    if (ret.priceReduced !== undefined)
        ret.priceReduced = Math.floor(ret.priceReduced * 100 ) / 100
    if (ret.priceFull < 0)
        throw Error("Negative full price!" + ret.priceFull)
    if (ret.priceReduced < 0)
        throw Error("Negative reduced price!" + ret.priceReduced)
    if (ret.priceFull === NaN || ret.fullPrice === 0)
        throw Error("Invalid priceFull " +  ret.priceFull)
    if (ret.priceReduced === NaN)
        throw Error("Invalid reducedPrice " +  ret.priceReduced)
    if (product.type === "OFFLINE")
    {
        ret.countFull = 2
        ret.count = 2
        ret.countReduced = 0
    }
    else
    {
        ret.countFull = 1
        ret.count = 1
        ret.countReduced = 0
    }
    ret.amount = ret.countFull * ret.priceFull
}
